var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_3210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7246 15.4999C16.5163 14.9083 17.1663 13.6166 17.1663 12.6333V6.44161C17.1663 5.41661 16.3829 4.28326 15.4246 3.92493L11.2663 2.3666C10.5746 2.10827 9.44127 2.10827 8.7496 2.3666L4.59127 3.92493C3.63294 4.28326 2.84961 5.41661 2.84961 6.44161V12.6333C2.84961 13.6166 3.49959 14.9083 4.29126 15.4999L7.87461 18.1749C9.04961 19.0583 10.9829 19.0583 12.1579 18.1749L12.7746 17.7083",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99909 9.59985C9.96576 9.59985 9.92409 9.59985 9.89076 9.59985C9.10742 9.57485 8.48242 8.92484 8.48242 8.13318C8.48242 7.32485 9.14076 6.6665 9.9491 6.6665C10.7574 6.6665 11.4158 7.32485 11.4158 8.13318C11.4074 8.93318 10.7824 9.57485 9.99909 9.59985Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34121 11.9333C7.54121 12.4666 7.54121 13.3416 8.34121 13.875C9.24954 14.4833 10.7412 14.4833 11.6495 13.875C12.4495 13.3416 12.4495 12.4666 11.6495 11.9333C10.7495 11.325 9.25788 11.325 8.34121 11.9333Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_3210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranches);
export default __webpack_public_path__ + "static/media/branches.d0b32cf174e369a60cf58ac97e35cddf.svg";
export { ForwardRef as ReactComponent };